import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  QueryList
} from '@angular/core';
import { CountryDefaultDirective, CountryDirective } from '../directives';
import { CountryComponentRegistryService } from '../services';

@Component({
  selector: 'country-wrapper',
  templateUrl: './country-wrapper.component.html'
})
export class CountryWrapperComponent implements AfterContentInit {
  @ContentChildren(CountryDirective)
  countryDirectives!: QueryList<CountryDirective>;
  @ContentChild(CountryDefaultDirective)
  countryDefaultDirective!: CountryDefaultDirective;
  countryToShow?: CountryDirective | CountryDefaultDirective;

  constructor(
    private readonly registryService: CountryComponentRegistryService
  ) {
    this.loadComponent();
  }

  ngAfterContentInit() {
    this.loadComponent();
  }

  private loadComponent() {
    const country = this.registryService.getCountry();
    this.countryToShow =
      this.countryDirectives?.find((a) => a.country === country) ||
      this.countryDefaultDirective;
  }
}
